import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_CATALOG_HEALTH = `${URL_RETAILER_SCOPED}/catalog-health`

export type DashRouteSet = DashRouteType<'catalog-health'>

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'catalog-health': URL_CATALOG_HEALTH,
}

export type DomainRouteName = keyof typeof routes
